import React from "react";
import styled from "styled-components";

export const TableDataValue = styled.td`
    word-break: break-word;
`;
export const ComparisonRow = styled.tr`
    font-weight: ${({ changed }) => (changed ? "bold" : "normal")};
`;
